module.exports = [
    {
        "data": null,
        "idPrimary": 38551826,
        "idContent": "headshot_01",
        "label": "Headshot 1:",
        "crop": null
    },
    {
        "data": null,
        "idPrimary": 38551827,
        "idContent": "headshot_02",
        "label": "Headshot 2:",
        "crop": null
    },
    {
        "data": null,
        "idPrimary": 38551825,
        "idContent": "photo_01",
        "label": "Photo 1:",
        "crop": null
    }
]
